import { ILocation, TLocation } from 'shared/types/location';

export const isNormalLocation = (location: TLocation): location is ILocation => {
  return typeof location === 'object' && 'id' in location;
};
